(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sage-home-appointment"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initializeAppointments(root) {
    const now = new Date();
    const today = [now.getFullYear(), String(now.getMonth() + 1).padStart(2, '0'), String(now.getDate()).padStart(2, '0')].join('-');
    root.querySelectorAll('[data-sage-appointment-date]').forEach(input => { input.min = today; });
    root.querySelectorAll('.sage-home-appointment').forEach(section => {
      if (section.dataset.appointmentReady) return;
      section.dataset.appointmentReady = 'true';
      const dialog = section.querySelector('dialog');
      const opener = section.querySelector('[data-sage-appointment-open]');
      let previousOverflow = '';
      function open() {
        if (dialog.open) return;
        previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        const message = dialog.querySelector('[role="status"], [role="alert"]');
        if (message) message.focus();
      }
      opener.addEventListener('click', open);
      section.querySelector('[data-sage-appointment-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow;
        opener.focus();
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      if (dialog.querySelector('[role="status"], [role="alert"]')) open();
    });
  }
  initializeAppointments(document);
  document.addEventListener('shopify:section:load', event => initializeAppointments(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
